// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor3 from '@/game/prefabs/World/Mentors/Mentor3';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level12 extends TilemapScene {
  constructor() {
    super('Level12');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // desert_biome_2
    const desert_biome_2 = this.add.tilemap('desert-biome-2');
    desert_biome_2.addTilesetImage('desert sands v01', 'desert sands v01');
    desert_biome_2.addTilesetImage(
      'desert sands prefabs',
      'desert sands prefabs',
    );
    desert_biome_2.addTilesetImage('bonus shadows', 'bonus shadows');
    desert_biome_2.addTilesetImage('collision', 'collision & alpha');

    // terrain_1
    desert_biome_2.createLayer(
      'terrain',
      ['desert sands v01', 'desert sands prefabs'],
      0,
      0,
    );

    // deco
    desert_biome_2.createLayer('deco 1', ['desert sands v01'], 0, 0);

    // under_cliffs_1
    desert_biome_2.createLayer(
      'under cliffs',
      ['bonus shadows', 'desert sands v01'],
      0,
      0,
    );

    // cliffs_1
    desert_biome_2.createLayer(
      'cliffs',
      ['desert sands prefabs', 'desert sands v01'],
      0,
      0,
    );

    // cliff_shadows_1
    desert_biome_2.createLayer('cliff shadows', ['bonus shadows'], 0, 0);

    // deco_over_cliff_1
    desert_biome_2.createLayer('deco over cliff', ['desert sands v01'], 0, 0);

    // cOLLISION_1
    const cOLLISION_1 = desert_biome_2.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.setInteractive(
      new Phaser.Geom.Polygon('0 132 400 0 800 132 800 528 0 528'),
      Phaser.Geom.Polygon.Contains,
    );
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 44, 454);
    this.add.existing(player);

    // portal
    const portal = new Portal(this, 774, 70);
    this.add.existing(portal);

    // worldNode
    const worldNode = new WorldNode(this, 69, 275);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 320, 392);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 744, 448);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 528, 104);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 240, 72);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 416, 232);
    this.add.existing(worldNode_5);

    // forestTree1
    const forestTree1 = new ForestTree1(
      this,
      688,
      384,
      'desert cactuses 32x',
      1,
    );
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(
      this,
      656,
      368,
      'desert cactuses 32x',
      1,
    );
    this.add.existing(forestTree);
    forestTree.scaleX = -1;
    forestTree.scaleY = 1;

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      592,
      416,
      'desert cactuses 32x',
      2,
    );
    this.add.existing(forestTree_1);
    forestTree_1.scaleX = 1;
    forestTree_1.scaleY = 1;

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      480,
      48,
      'desert cactuses 32x',
      2,
    );
    this.add.existing(forestTree_2);
    forestTree_2.scaleX = 1;
    forestTree_2.scaleY = 1;

    // forestTree_3
    const forestTree_3 = new ForestTree1(this, 376, 32, 'desert 16x', 2);
    this.add.existing(forestTree_3);
    forestTree_3.scaleX = 1;
    forestTree_3.scaleY = 1;

    // forestTree_4
    const forestTree_4 = new ForestTree1(this, 184, 48, 'desert 16x', 2);
    this.add.existing(forestTree_4);
    forestTree_4.scaleX = 1;
    forestTree_4.scaleY = 1;

    // forestTree_5
    const forestTree_5 = new ForestTree1(this, 104, 112, 'desert 16x', 2);
    this.add.existing(forestTree_5);
    forestTree_5.scaleX = 1;
    forestTree_5.scaleY = 1;

    // forestTree_6
    const forestTree_6 = new ForestTree1(this, 72, 192, 'desert 16x', 2);
    this.add.existing(forestTree_6);
    forestTree_6.scaleX = 1;
    forestTree_6.scaleY = 1;

    // forestTree_7
    const forestTree_7 = new ForestTree1(this, 56, 208, 'desert 16x', 2);
    this.add.existing(forestTree_7);
    forestTree_7.scaleX = 1;
    forestTree_7.scaleY = 1;

    // forestTree_8
    const forestTree_8 = new ForestTree1(this, 584, 336, 'desert 16x', 3);
    this.add.existing(forestTree_8);
    forestTree_8.scaleX = 1;
    forestTree_8.scaleY = 1;

    // forestTree_9
    const forestTree_9 = new ForestTree1(this, 552, 320, 'desert 16x', 3);
    this.add.existing(forestTree_9);
    forestTree_9.scaleX = 1;
    forestTree_9.scaleY = 1;

    // forestTree_10
    const forestTree_10 = new ForestTree1(this, 744, 128, 'desert 16x', 3);
    this.add.existing(forestTree_10);
    forestTree_10.scaleX = 1;
    forestTree_10.scaleY = 1;

    // forestTree_11
    const forestTree_11 = new ForestTree1(this, 760, 48, 'desert 16x', 3);
    this.add.existing(forestTree_11);
    forestTree_11.scaleX = 1;
    forestTree_11.scaleY = 1;

    // forestTree_12
    const forestTree_12 = new ForestTree1(this, 136, 208, 'desert 16x', 3);
    this.add.existing(forestTree_12);
    forestTree_12.scaleX = 1;
    forestTree_12.scaleY = 1;

    // forestTree_13
    const forestTree_13 = new ForestTree1(this, 472, 464, 'desert 16x', 3);
    this.add.existing(forestTree_13);
    forestTree_13.scaleX = 1;
    forestTree_13.scaleY = 1;

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      504,
      320,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_14);
    forestTree_14.scaleX = 1;
    forestTree_14.scaleY = 1;

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      168,
      480,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_15);
    forestTree_15.scaleX = 1;
    forestTree_15.scaleY = 1;

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      232,
      528,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_16);
    forestTree_16.scaleX = 1;
    forestTree_16.scaleY = 1;

    // mentor
    const mentor = new Mentor3(this, 104, 432);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 768, 144);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 424, 440);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 336, 88);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 32, 376);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 11;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 11;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 11;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 11;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 11;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 11;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 11;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 11;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 11;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 11;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.desert_biome_2 = desert_biome_2;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor3;
  private desert_biome_2!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.desert_biome_2,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
